<template>
   <div class="layout-px-spacing" v-if="
        this.$can('admin') ||
        this.$can('office') ||
        this.$can('rola-pobocka') ||
        this.$can('reklamacie') ||
        this.$can('skladnik') ||
        this.$can('kurier') ||
        this.$can('infolinka')
   ">
      <portal to="breadcrumb">
         <ul class="navbar-nav flex-row">
            <li>
               <div class="page-header">
                  <nav class="breadcrumb-one" aria-label="breadcrumb">
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="javascript:;">{{ $t("users") }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page"><span>{{ $t("profile") }}</span></li>
                     </ol>
                  </nav>
               </div>
            </li>
         </ul>
      </portal>

      <div class="row layout-spacing">
         <div class="col-lg-12 layout-top-spacing">
            <div class="panel">
               <div class="panel-heading">
                  <div class="row">
                     <div class="col-12">
                        <h3>{{ $t("create_order") }}</h3>
                     </div>
                  </div>
               </div>
               <div class="panel-body">
                  <b-form @submit.prevent="submitForm" ref="form">
                     <div class="row align-items-center mb-md-4">
                        <div class="col-12 mt-0">
                           <b-form-row class="over-1">
                              <b-form-group :label="$t('order_name')" class="col-md-12">
                                 <b-form-input :state="validateState('name')" v-model="$v.form.name.$model" type="text"
                                               placeholder=""></b-form-input>
                                 <b-form-invalid-feedback>{{ $t("required_field") }}</b-form-invalid-feedback>
                              </b-form-group>
                              <b-form-group :label="$t('identifier')" class="col-md-6 d-none">
                                 <b-form-input :state="validateState('identifier')" v-model="$v.form.identifier.$model" type="text"
                                               :placeholder="$t('if_not_filled')"></b-form-input>
                                 <b-form-invalid-feedback>{{ $t("required_field") }}</b-form-invalid-feedback>
                              </b-form-group>
                           </b-form-row>
                           <b-form-row class="over-1">
                              <b-form-group :label="$t('customer')" class="col-md-6">
                                 <b-form-input v-if="form.from_user_name && !$can('admin') && !$can('office') && !$can('rola-pobocka') && !$can('reklamacie')" :state="validateState('from_user_name')" v-model="form.from_user_name.name" type="text" readonly placeholder=""></b-form-input>
                                 <multiselect v-else :max-height="200" :showNoResults="false" :state="validateState('from_user_id')" v-model="$v.form.from_user_id.$model" :deselectLabel="$t('clear')" :selectLabel="$t('select')" :selectedLabel="$t('selected')" :tag-placeholder="$t('add_as_new_tag')" :placeholder="$t('search')" label="name" track-by="id" :can-deselect="false" :allow-empty="false" :options="users" :multiple="false" :closeOnSelect="true"></multiselect>
                                 <b-form-invalid-feedback>{{ $t("required_field") }}</b-form-invalid-feedback>
                              </b-form-group>

                              <b-form-group class="col-md-6" :label="$t('supplier')">
                                 <multiselect @input="onSupplierChange" @change="onSupplierChange" :max-height="200" :showNoResults="false" :state="validateState('to_user_id')" v-model="$v.form.to_user_id.$model" :deselectLabel="$t('clear')" :selectLabel="$t('select')" :selectedLabel="$t('selected')" :tag-placeholder="$t('add_as_new_tag')" :placeholder="$t('search')" label="name" track-by="id" :can-deselect="false" :allow-empty="false" :options="usersWithoutMe" :multiple="false" :closeOnSelect="true"></multiselect>
                                 <b-form-invalid-feedback>{{ $t("required_field") }}</b-form-invalid-feedback>
                              </b-form-group>
                           </b-form-row>
                           <b-form-row>
                              <b-form-group class="col-md-12" :label="$t('products')">
                                 <div class="form-repeater w-100 custom-table">
                                    <table class="table table-responsive-detail">
                                       <thead>
                                          <tr>
                                             <th style="width: 30%;min-width: 200px">{{ $t("name") }}</th>
                                             <th style="width: 30%;min-width: 200px">{{ $t("count") }}</th>
                                             <th style="width: 30%;min-width: 200px">{{ $t("note") }}</th>
                                             <th class="text-center">{{ $t("delete") }}</th>
                                          </tr>
                                       </thead>
                                       <tbody class="form-repeater">
                                          <tr v-for="(row, index) in form.rows" :key="index" class="row-product-item">
                                             <td>
                                                <div v-if="row.id != null" class="row-product-item-image-box">
                                                   <img v-if="row.id.attachments[0]" :src="url + '/' +  row.id.attachments[0].file_path" @click="() => showRowImg(index)" loading="lazy">
                                                   <svg v-else
                                                        viewBox="0 0 24 24" width="24" height="24"
                                                        stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"
                                                        stroke-linejoin="round" class="css-i6dzq1">
                                                      <path
                                                        d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                                      </path>
                                                      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                                      <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                                   </svg>
                                                   <div class="d-flex align-items-center">
                                                      <h6 class="mb-0 ml-2">{{ row.id.name }}</h6>
                                                   </div>
                                                </div>
                                             </td>
                                             <td>
                                                <b-input-group>
                                                   <template #append>
                                                      <b-input-group-text><strong v-if="row.id" class="">{{ row.id.unit.name }}</strong></b-input-group-text>
                                                   </template>
                                                   <b-form-input v-model.number="row.quantity" type="number" min="0" :max="row.user_quantity !== null && row.user_quantity !== undefined ? row.user_quantity : null" :placeholder="row.user_quantity !== null && row.user_quantity !== undefined ? `Max: ${row.user_quantity}` : ''"></b-form-input>
                                                </b-input-group>
                                                <h6 v-if="row.user_quantity !== null && row.user_quantity !== undefined && parseFloat(row.quantity) > row.user_quantity" class="text-danger d-block mt-1 mb-0" v-html="$t('only_available').replace('{0}', '<strong>' + row.user_quantity + '</strong>').replace('{1}', '<strong>' + (row.id && row.id.unit ? row.id.unit.name : '') + '</strong>')"></h6>
                                             </td>
                                             <td>
                                                <b-form-input v-model="row.note" type="text" placeholder=""></b-form-input>
                                             </td>
                                             <td class="text-center align-middle">
                                                <b-button variant="outline-danger" @click="removeRow(index)">
                                                   <svg
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     width="24"
                                                     height="24"
                                                     viewBox="0 0 24 24"
                                                     fill="none"
                                                     stroke="currentColor"
                                                     stroke-width="2"
                                                     stroke-linecap="round"
                                                     stroke-linejoin="round"
                                                     class="feather feather-trash-2"
                                                   >
                                                      <polyline points="3 6 5 6 21 6"></polyline>
                                                      <path
                                                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                      <line x1="10" y1="11" x2="10" y2="17"></line>
                                                      <line x1="14" y1="11" x2="14" y2="17"></line>
                                                   </svg>
                                                </b-button>
                                             </td>
                                          </tr>

                                          <tr class="text-md-center">
                                             <td colspan="6">
                                                <b-button variant="outline-dark" @click="show_items_modal" :disabled="!form.to_user_id || isLoadingItems">
                                                   <b-spinner v-if="isLoadingItems && form.to_user_id" small class="loader-xs mr-1"></b-spinner>
                                                   <svg v-if="!(isLoadingItems && form.to_user_id)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                                        class="feather feather-plus-circle mr-1">
                                                      <circle cx="12" cy="12" r="10"></circle>
                                                      <line x1="12" y1="8" x2="12" y2="16"></line>
                                                      <line x1="8" y1="12" x2="16" y2="12"></line>
                                                   </svg>
                                                   {{ $t("add_products") }}
                                                </b-button>
                                             </td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </b-form-group>
                           </b-form-row>

                           <b-form-row>
                              <b-form-group class="col-md-12" :label="$t('global_note')">
                                 <b-form-textarea id="textarea" v-model="$v.form.note.$model" :placeholder="$t('note')"
                                                  rows="4"></b-form-textarea>
                              </b-form-group>
                           </b-form-row>
                        </div>
                        <vue-easy-lightbox :visible="visibleRowImage" :imgs="lightboxRowImages" :index="lightboxRowIndex" @hide="handleRowHide"></vue-easy-lightbox>
                     </div>
                     <div class="row">
                        <div class="col-12 text-right">
                           <b-button @click="$router.go(-1)" variant="danger" class="mt-3">{{ $t("cancel") }}</b-button>
                           <b-button type="submit" variant="primary" class="mt-3 ml-2">{{ $t("create") }}</b-button>
                        </div>
                     </div>
                  </b-form>
               </div>
            </div>

            <b-modal dialog-class="modal-fullscreen" centered id="addProductModal" :static="true" :title="$t('choose_product')" size="xl" no-close-on-esc>
               <b-form-input type="text" v-model="itemSearch" :placeholder="$t('search_product')"></b-form-input>
               <div>
                  <div class="d-flex align-items-center mt-2 categories-box">
                     <div v-for="item in categories" :key="item.id" class="mr-3">
                        <b-form-checkbox
                          v-model="selectedCategories"
                          :value="item.id"
                        >
                           {{ item.name }}
                        </b-form-checkbox>
                     </div>
                  </div>
                  <h6 class="reset-category-link mb-0" @click="resetFilters" v-if="shouldShowReset">{{ $t("reset") }}</h6>
               </div>


               <DynamicScroller v-if="filteredItems.length > 0" class="products-scroller" :items="filteredItems" :min-item-size="minItemSize" key-field="id" ref="productsScroller">
                  <template #default="{ item, index }">
                     <div :class="['product-card', isSelected(item) ? 'product-card-active' : '']">
                        <div class="product-card-box px-2 py-2">
                           <div class="d-flex align-items-center gap-3">
                              <div class="product-card-item">
                                 <img v-if="item.attachments[0]" :src="url + '/' +  item.attachments[0].file_path" @click="() => showImg(index)" loading="lazy">
                                 <svg v-else
                                    v-b-tooltip.hover
                                    viewBox="0 0 24 24" width="24" height="24"
                                    stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"
                                    stroke-linejoin="round" class="css-i6dzq1">
                                    <path
                                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                    </path>
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                    <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                 </svg>
                              </div>
                              <div>
                                 <h6 class="mb-0 ml-2">{{ item.name }}</h6>
                                 <h6 v-if="item.user_quantity !== null && item.user_quantity !== undefined && parseFloat(item.user_quantity) > 0" class="text-danger ml-2 mb-0 mt-1" style="font-size: 1em" v-html="$t('in_stock') + ': <strong>' + item.user_quantity + ' ' + (item.unit ? item.unit.name : '') + '</strong>'"></h6>
                              </div>
                           </div>
                           <div class="d-flex align-items-center">
                              <button class="btn btn-outline-dark" @click="toggleItem(item)" v-if="!isSelected(item)">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="feather feather-plus-circle">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="8" x2="12" y2="16"></line>
                                    <line x1="8" y1="12" x2="16" y2="12"></line>
                                 </svg>
                              </button>
                              <button class="btn btn-outline-danger" @click="toggleItem(item)" v-else>
                                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2" data-v-5522efca="">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                 </svg>
                              </button>
                           </div>
                        </div>
                     </div>
                     <!--                     <div class="add-item-box">-->
                     <!--                        <div class="add-item-box-img">-->
                     <!--                           <img v-if="item.attachments[0]" :src="url + '/' +  item.attachments[0].file_path" @click="() => showImg(index)" loading="lazy">-->
                     <!--                           <svg v-else-->
                     <!--                                v-b-tooltip.hover-->
                     <!--                                viewBox="0 0 24 24" width="24" height="24"-->
                     <!--                                stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"-->
                     <!--                                stroke-linejoin="round" class="css-i6dzq1 mr-2">-->
                     <!--                              <path-->
                     <!--                                d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">-->
                     <!--                              </path>-->
                     <!--                              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>-->
                     <!--                              <line x1="12" y1="22.08" x2="12" y2="12"></line>-->
                     <!--                           </svg>-->
                     <!--                        </div>-->
                     <!--                        <h6>{{ item.name }}</h6>-->
                     <!--                     </div>-->
                  </template>
               </DynamicScroller>
               <div v-if="filteredItems.length === 0 && form.to_user_id && items.length === 0" class="text-center mt-5">
                  <p class="text-muted">{{ form.to_user_id.name }} {{ $t("has_no_products_in_stock") || "nemá žiadne produkty na sklade" }}</p>
               </div>
               <div v-else-if="filteredItems.length === 0 && form.to_user_id && items.length > 0" class="text-center mt-5">
                  <p class="text-muted">{{ $t("no_products_match_search") || "Žiadne produkty nezodpovedajú vyhľadávaniu" }}</p>
               </div>

               <vue-easy-lightbox :visible="visible" :imgs="lightboxImages" :index="lightboxIndex" @hide="handleHide"></vue-easy-lightbox>
               <template #modal-footer>
                  <b-button variant="primary" data-dismiss="modal" @click="confirmSelectedItems">{{ $t("save") }}</b-button>
                  <b-button variant="cancel" data-dismiss="modal" @click="cancel_item">{{ $t("cancel") }}</b-button>
               </template>

               <objednavka-kosik :items="selectedItemsFromModal" @remove="removeItemFromModal" @clear="clearAllSelectedItems" />
            </b-modal>
         </div>
      </div>
   </div>
   <div class="layout-px-spacing d-flex align-items-center justify-content-center" v-else>
      <div class="row layout-top-spacing">
         <div class="col-12">
            <h4 class="text-center px-3">{{ $t("not_allowed") }}</h4>
         </div>
      </div>
   </div>
</template>

<script>
   import { validationMixin } from "vuelidate";
   import { required } from "vuelidate/lib/validators";
   import Multiselect from "vue-multiselect";
   import "vue-multiselect/dist/vue-multiselect.min.css";
   import "../../assets/sass/global/table.scss";
   import { urlMixin } from "@/mixins/url";
   import ObjednavkaKosik from "@/views/objednavky/objednavka-kosik.vue";
   import { DynamicScroller } from "vue-virtual-scroller";
   import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

   export default {
      name: "new",
      mixins: [validationMixin, urlMixin],
      components: { ObjednavkaKosik, Multiselect, DynamicScroller },

      validations: {
         form: {
            name: {},
            identifier: {},
            from_user_id: {
               required
            },
            from_user_name: {
               required
            },
            to_user_id: {
               required
            },
            note: {},
            rows: {
               required
            }
         }
      },
      data() {
         return {
            form: {
               name: "",
               identifier: null,
               from_user_name: null,
               from_user_id: null,
               to_user_id: null,
               note: "",
               // rows: [{ id: 0, name: "", quantity: "", note: "", unit: "" }]
               rows: []
            },
            errors: [],
            itemSearch: "",
            categories: {},
            selectedCategories: [],
            visible: false,
            lightboxImages: [],
            lightboxIndex: 0,
            visibleRowImage: false,
            lightboxRowImages: [],
            lightboxRowIndex: 0,
            selectedItemsFromModal: [],
            vw: typeof window !== 'undefined' ? window.innerWidth : 1024,
            isLoadingItems: false
         };
      },
      created() {
         this.$axios.get("user")
           .then(response => {
              if (response.data) {
                 this.form.from_user_id = response.data.pouzivatel;
                 this.form.from_user_name = response.data.pouzivatel;

              }
           });
         this.$store.dispatch("user/getAllUsers");

         this.$axios.get("item_categories")
           .then(response => {
              this.categories = response.data;
              this.selectedCategories = response.data.map((cat) => cat.id);
           });


         //DORIEŠIŤ
         const user = this.users.filter(user => user.default_store === true);
         if (user.length > 0) {
         this.form.to_user_id = user[0];
            this.$nextTick(() => {
               this.loadItems();
            });
           }

      },
      mounted() {
         window.addEventListener('resize', this.onResize);
      },
      beforeDestroy() {
         window.removeEventListener('resize', this.onResize);
      },
      computed: {
         users() {
            return this.$store.state.user.users;
         },
         usersWithoutMe() {
            return this.$store.state.user.users.filter(user => user.id !== this.form.from_user_id);
         },
         items() {
            return this.$store.state.item.items;
         },
         filteredItems() {
            const normalize = (str) =>
              str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

            const search = normalize(this.itemSearch);

            return this.items.filter((item) => {
               const inSearch = normalize(item.name).includes(search);
               // Custom products don't have category, so skip category filter for them
               const hasCategory = item.category && item.category.id;
               const inCategory = !hasCategory || this.selectedCategories.length === 0 || this.selectedCategories.includes(item.category.id);
               return inSearch && inCategory;
            });
         },
         shouldShowReset() {
            return (
              this.itemSearch.trim() !== "" ||
              this.selectedCategories.length !== this.categories.length
            );
         },
         isMobile() { return this.vw < 768; },
         minItemSize() { return this.isMobile ? 160 : 95; }

      },
      methods: {
         onResize() {
            const w = window.innerWidth;
            if (w !== this.vw) {
               this.vw = w;
               // po zmene výšky daj scrolleru vedieť, nech prepočíta polohy
               this.$nextTick(() => {
               const sc = this.$refs.productsScroller;
               if (sc && sc.forceUpdate) sc.forceUpdate();
               });
            }
         },
         removeRow(index) {
            this.form.rows.splice(index, 1);
         },
         cancel_item() {
            this.selectedItemsFromModal = [];
            this.resetFilters();
            this.$bvModal.hide("addProductModal");
         },
         confirmSelectedItems() {
            const selectedIds = this.selectedItemsFromModal.map(i => i.id);

            const updatedRows = [];

            this.form.rows.forEach((row) => {
               if (selectedIds.includes(row.id.id)) {
                  const selected = this.selectedItemsFromModal.find(i => i.id === row.id.id);
                  updatedRows.push({
                     id: selected,
                     name: selected.name,
                     quantity: row.quantity || "",
                     note: row.note || "",
                     unit: selected.unit,
                     user_quantity: selected.user_quantity
                  });
               }
            });

            this.selectedItemsFromModal.forEach((item) => {
               const exists = updatedRows.some(r => r.id?.id === item.id);
               if (!exists) {
                  updatedRows.push({
                     id: item,
                     name: item.name,
                     quantity: "",
                     note: "",
                     unit: item.unit,
                     user_quantity: item.user_quantity
                  });
               }
            });

            this.form.rows = updatedRows;
            this.resetFilters();
            this.$bvModal.hide("addProductModal");
         },
         show_items_modal() {
            if (!this.form.to_user_id) {
               this.$toast.error(this.$t("please_select_supplier") || "Prosím vyberte dodávateľa");
               return;
            }
            this.selectedItemsFromModal = this.form.rows
              .filter(r => r.id !== null)
              .map(r => {
                 const item = this.items.find(i => i.id === r.id?.id || i.id === r.id);
                 return item ? item : null;
              })
              .filter(i => i);
            this.$bvModal.show("addProductModal");
         },
         loadItems() {
            const userId = this.form.to_user_id ? this.form.to_user_id.id : null;
            this.isLoadingItems = true;
            this.$store.dispatch("item/getItems", { 
               all: 1, 
               include_custom: true,
               user_id: userId,
               only_in_stock: true,
               showLoader: false
            }).then(() => {
               this.isLoadingItems = false;
            }).catch(() => {
               this.isLoadingItems = false;
            });
         },
         onSupplierChange() {
            this.$v.form.to_user_id.$touch();
            // Vymazať produkty pri zmene dodávateľa
            this.form.rows = [];
            this.$nextTick(() => {
               this.loadItems();
            });
         },
         resetFilters() {
            this.selectedCategories = this.categories.map((cat) => cat.id);
            this.itemSearch = "";
         },
         removeItemFromModal(item) {
            this.selectedItemsFromModal = this.selectedItemsFromModal.filter(i => i.id !== item.id);
         },
         clearAllSelectedItems() {
            this.selectedItemsFromModal = [];
         },
         showRowImg(index) {
            this.lightboxRowImages = this.form.rows
              .filter(row => row.id && row.id.attachments)
              .flatMap(row => row.id.attachments.map(att => this.url + "/" + att.file_path));

            const clickedImage = this.form.rows[index]?.id?.attachments?.[0];

            if (clickedImage) {
               const fullPath = this.url + "/" + clickedImage.file_path;
               this.lightboxRowIndex = this.lightboxRowImages.findIndex(img => img === fullPath);
            } else {
               this.lightboxRowIndex = 0;
            }

            this.visibleRowImage = true;
         },
         showImg(itemIndex) {
            this.lightboxImages = this.filteredItems
              .flatMap(item => item.attachments.map(att => this.url + "/" + att.file_path));

            // Nájde správny index podľa poradia obrázka, ktorý si klikol
            const clickedImage = this.filteredItems[itemIndex]?.attachments?.[0];
            if (clickedImage) {
               const fullPath = this.url + "/" + clickedImage.file_path;
               this.lightboxIndex = this.lightboxImages.findIndex(img => img === fullPath);
            } else {
               this.lightboxIndex = 0;
            }

            this.visible = true;
         },
         handleHide() {
            this.visible = false;
         },
         handleRowHide() {
            this.visibleRowImage = false;
         },
         validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
         },
         toggleItem(item) {
            const index = this.selectedItemsFromModal.findIndex(i => i.id === item.id);
            if (index === - 1) {
               this.selectedItemsFromModal.push(item);
            } else {
               this.selectedItemsFromModal.splice(index, 1);
            }
         },
         isSelected(item) {
            return this.selectedItemsFromModal.some(i => i.id === item.id);
         },
         submitForm() {
            const t = this;

            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
               t.$toast.error(t.$t("product_or_supplier_missing"));
               return;
            }

            this.form.rows.forEach(function(value) {
               if (value.id === 0 || value.id === null) {
                  t.errors.push(t.$t("missing_product"));
                  if (value.quantity === "") {
                     t.errors.push(t.$t("missing_quantity"));
                  }
               } else {
                  if (value.quantity === "") {
                     t.errors.push(t.$t("missing_quantity"));
                  }
               }
            });


            if (t.errors.length > 0) {
               t.$toast.error(t.errors[0]);
               t.errors = [];
            } else {
               this.$v.form.$touch();
               if (this.$v.form.$anyError) {
                  t.$toast.error(t.$t("missing_credentials"));
                  return;
               }

               let data = {
                  name: this.form.name,
                  identifier: this.form.identifier,
                  from_user_id: this.form.from_user_id.id,
                  to_user_id: this.form.to_user_id.id,
                  note: this.form.note
               };

               let formData = new FormData();

               for (let key in data) {
                  formData.append(key, data[key]);
               }

               this.form.rows.forEach(function(value, index) {
                  // Send translated name (value.name is already translated by ItemResource)
                  formData.append("items[" + index + "][name]", value.name || "");
                  formData.append("items[" + index + "][id]", value.id.id);
                  formData.append("items[" + index + "][quantity]", value.quantity);
                  formData.append("items[" + index + "][note]", value.note);
               });

               this.$axios.post("orders", formData)
                 .then((response) => {

                    if (response.status === 200 || response.status === 201) {
                       this.$router.go(- 1);
                       t.$toast.success(response.data.message);
                    } else {
                       console.log(response);
                       t.$toast.error(response.data.message);

                    }
                    // console.log(response)
                    // t.$toast.success(response.data.message);

                 }).catch(error => {
                  console.log(error);
                  t.$toast.error(error.response.data.message);
               });
            }


         }
      },
      watch: {
         itemSearch() {
            this.$nextTick(() => {
               requestAnimationFrame(() => {
               const sc = this.$refs.productsScroller;
               if (sc && sc.scrollToPosition) sc.scrollToPosition(0);
               else if (sc && sc.$el) sc.$el.scrollTop = 0; // fallback
               });
            });
         },
         users: {
            handler(newUsers) {
               // Nastav defaultneho dodávateľa, keď sa users načítajú
               if (newUsers && newUsers.length > 0 && !this.form.to_user_id) {
                  const user = newUsers.filter(user => user.default_store === true);
                  if (user.length > 0) {
                     this.form.to_user_id = user[0];
                     this.$nextTick(() => {
                        this.loadItems();
                     });
                  }
               }
            },
            immediate: true
         }
      }
   };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
   .unit-multiselect {

      .multiselect__tags {
         border-radius: 0 0.2rem 0.2rem 0;
         background: #f1f2f3;
         min-height: 45.4px !important;
         border: 1px solid #bfc9d4;

      }

      .multiselect__single,
      .multiselect__input {
         background: #f1f2f3;
      }
   }

   .products-scroller {
      height: calc(100vh - 66px - 45px - 16px - 16px - 8px - 24px - 16px - 70px - 8px);
      margin-top: 1rem;
   }
</style>
